module.exports = __webpack_public_path__ + "static/PG_240619_304-5d640d3376fc42e44a4e1deb50f1f35a.jpg";